import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Action to get shared folders for a particular user.
 * @param mailboxInfo The mailbox from where the folders will be fetched.
 * @param actionSource Source from where this action is called.
 *
 */
export interface MANUAL_SYNC_FOLDERS_SORT_CHANGEActionMessage {
    mailboxInfo: MailboxInfo;
    actionSource: string;
}
export const manualSyncFoldersSortChange: (
    mailboxInfo: MailboxInfo,
    actionSource: string
) => MANUAL_SYNC_FOLDERS_SORT_CHANGEActionMessage = action(
    'MANUAL_SYNC_FOLDERS_SORT_CHANGE',
    (
        mailboxInfo: MailboxInfo,
        actionSource: string
    ): MANUAL_SYNC_FOLDERS_SORT_CHANGEActionMessage => {
        return {
            mailboxInfo,
            actionSource,
        };
    }
);
